import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { AuthProvider } from './contexts/AuthContext.tsx';
import './index.css';
import App from './App';

axios.defaults.withCredentials = true;

// Серверный SEO-shell вставляет #seo-prerender для ботов; убираем после старта SPA,
// чтобы не дублировать H1 для пользователей.
const seoPrerender = document.getElementById('seo-prerender');
if (seoPrerender) {
  seoPrerender.remove();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);